import { List, Map } from 'immutable'
import { createSelector } from 'reselect'

import { fallbackICASPhoneNumber } from '@lyrahealth-inc/shared-app-logic/src/models/searchForCare/SearchForCare'
import { type ChildCompetencyPolicy } from '@lyrahealth-inc/shared-app-logic/src/models/user/User'

import { getCountryListForCustomerCountry } from '../customerCountry/customerCountrySelectors'

export const getCurrentCountry = (state: $TSFixMe) => state.get('currentCountry', Map())

export const getCurrentCountryId = createSelector(getCurrentCountry, (country) => country?.get('id'))

export const getCurrentCountryIsoCode = createSelector(getCurrentCountry, (country) => country?.get('isoCode'))

export const getCurrentCountryChildCompetencyPolicy = createSelector(
  getCurrentCountry,
  (country): ChildCompetencyPolicy | null => country?.get('childCompetencyPolicy')?.toJS() ?? null,
)

export const getCurrentCountryOutOfCountryNumbersList = createSelector(
  [getCurrentCountryIsoCode, getCountryListForCustomerCountry],
  (isoCode, countryList) => {
    const list = countryList
      .find((country: $TSFixMe) => country.get('countryIsoCode') === isoCode)
      ?.get('outOfCountryNumbersList')
    if (!!list && !list.isEmpty()) {
      return list
    }
    return List([fallbackICASPhoneNumber])
  },
)

export const getCurrentCountryOutOfCountryNumbersArray = createSelector(
  getCurrentCountryOutOfCountryNumbersList,
  (outOfCountryNumbers) => outOfCountryNumbers?.toJS(),
)

export const getCurrentCountryTollFreeNumbersList = createSelector(
  [getCurrentCountryIsoCode, getCountryListForCustomerCountry],
  (isoCode, countryList) => {
    const list = countryList
      .find((country: $TSFixMe) => country.get('countryIsoCode') === isoCode)
      ?.get('tollFreeNumbersList')
    if (!!list && !list.isEmpty()) {
      return list
    }
    return List([fallbackICASPhoneNumber])
  },
)

export const getCurrentCountryTollFreeNumbersArray = createSelector(
  getCurrentCountryTollFreeNumbersList,
  (tollFreeNumbers) => tollFreeNumbers?.toJS(),
)

export const getCurrentCountryEmergencyNumbersList = createSelector(
  getCurrentCountry,
  (country) => country?.get('emergencyPhoneNumbersList') ?? List(),
)

export const getCurrentCountryName = createSelector(getCurrentCountry, (country) => country?.get('name'))
